import React from "react";
import Button from "../Button/Button";
import Spinner from "../Spinner/Spinner";
import { useShortcut } from "react-keyhub";
import { useModalContext } from "./ModalContext";
import { myShortcuts } from "../../../Shortcuts/myShortcuts";
function capitalizeFirstLetter(str) {
  if (!str) return str;
  const [first, ...rest] = str;
  return first.toUpperCase() + rest.join("");
}
interface PortalFooterProps {
  submitType?: any;
  submitform?: any;
  handleformclose?: any;
  SaveAndClose?: any;
  Cancletype?: any;
  Delete?: any;
  handleFileDelete?: any;
  UserRightsPortal?: any;
  TypeOfPortal?: any;
  disableupload?: any;
  name?: any;
  disabled?: any;
  loadingState?: any;
  renderContent?: any;
  Form_key?: string;
  showPrintButton?: boolean; // New prop to control print button visibility
  handlePagePrint?: () => void; // Function to handle print action
  ButtonTitle?: String;
  setDefaultPrint?: Boolean;
  openPrefFun?: () => void;
  handleKeydownFun?: (e: any) => void;
  showCancelButton?: Boolean
}
const PortalFooter = ({
  renderContent, // Function that returns the content to be rendered
  submitType,
  submitform,
  handleformclose,
  SaveAndClose,
  Cancletype,
  Delete,
  handleFileDelete,
  UserRightsPortal,
  TypeOfPortal,
  disableupload,
  name,
  disabled = false,
  loadingState,
  Form_key,
  showPrintButton, // Using new prop
  handlePagePrint, // Using function prop
  ButtonTitle = "",
  setDefaultPrint = false,
  openPrefFun,
  handleKeydownFun,
  showCancelButton = true
}: PortalFooterProps) => {
  const { getTopModal, settings } = useModalContext();
  const closeKey = (myShortcuts.closeForm as { keyCombo: string }).keyCombo;
  const baseText = Cancletype ? Cancletype : "Cancel";
  const cancelText =
    closeKey && Form_key && settings.visable_keys ? `${baseText} (${capitalizeFirstLetter(closeKey)})` : baseText;

  const SaveKey = (myShortcuts.saveandCloseForm as { keyCombo: string }).keyCombo;
  const baseSaveText = ButtonTitle ? ButtonTitle : "Save & Close";
  const SaveKeyText =
    SaveKey && Form_key && settings.visable_keys ? `${baseSaveText} (${capitalizeFirstLetter(SaveKey)})` : baseSaveText;

  const SaveonlyKey = (myShortcuts.saveForm as { keyCombo: string }).keyCombo;
  const baseSaveOnlyText = submitType?.length ? submitType : "Save";
  const SaveOnlyKeyText =
    SaveonlyKey && Form_key && settings.visable_keys
      ? `${baseSaveOnlyText} (${capitalizeFirstLetter(SaveonlyKey)})`
      : baseSaveOnlyText;

  useShortcut("closeForm", (event: KeyboardEvent) => {
    event.preventDefault();
    if (getTopModal() === Form_key && settings.enableshortcuts) {
      // console.log("modalStackmodalStackmodalStackmodalStack98089080", Form_key, handleformclose)
      //Esc key
      handleformclose();
    }
  });

  useShortcut("saveandCloseForm", (event: KeyboardEvent) => {
    //F4 key

    event.preventDefault();
    if (getTopModal() === Form_key && settings.enableshortcuts && !TypeOfPortal?.includes("View") && !disabled) {
      if (submitform) {
        submitform();
      } else {
        SaveAndClose();
      }
    }
  });

  useShortcut("saveForm", (event: KeyboardEvent) => {
    //F3 key
    event.preventDefault();
    if (getTopModal() === Form_key && settings.enableshortcuts && !TypeOfPortal?.includes("View") && !disabled) {
      // console.log("FunctionTriggered one Time", Form_key)
      SaveAndClose();
    }
  });

  // console.log(closeKey, "myShortcuts.closeForm?.keyCombo")
  return (
    <div>
      <div className={UserRightsPortal ? "rightsFooter modalfooter" : "modalfooter"}>
        <div className="AdditionalButtons">
          {setDefaultPrint && (
            <>
              <Button
                name="userPreference"
                text={"Set as default"}
                action={() => openPrefFun()}
                type=""
                // loadingState={loadingState}
                disabled={disabled}
                children=""
              />
            </>
          )}
          {showPrintButton && handlePagePrint && !loadingState && (
            <Button name="modalbutton" text={"Save & Print"} action={handlePagePrint} disabled={disabled} />
          )}
          {name && (
            <>
              <Button
                name="userPreference"
                text={"User Preference"}
                action={() => name()}
                type=""
                // loadingState={loadingState}
                disabled={disabled}
                children=""
              />
            </>
          )}
          {renderContent && renderContent()}
          {TypeOfPortal === "SearchSP" && (
            <Button
              name="modalbutton"
              text={"Re-Search SP"}
              action={() => {
                handleFileDelete && handleFileDelete();
              }}
              type=""
              // loadingState={loadingState}
              disabled={disabled}
              children=""
            />
          )}
          {/* {TypeOfPortal == "Edit Load" &&
            <Button
              name="modalbutton"
              text={"Copy Load"}
              action={() => handleFileDelete()}
              // loadingState={loadingState}
              disabled={disabled}
              children=""
            />} */}
        </div>
        <>
          {/* Other elements and logic */}
          {/* {renderContent && renderContent()} Invoking the render prop */}
        </>
        <div className={UserRightsPortal ? "rightsFooter modalfooter" : "modalfooter"}>
          {submitType !== "View" && !disableupload ? (
            <>
              {loadingState && typeof loadingState === "boolean" ? (
                <Button type="" name="modalbutton" text={<Spinner />} action="" disabled={true} children="" />
              ) : submitType ? (
                <Button
                  name="modalbutton"
                  text={SaveOnlyKeyText}
                  action={submitform}
                  // loadingState={loadingState}
                  disabled={disabled}
                  children=""
                  type=""
                />
              ) : (
                ""
              )}
              {/* <Button name="modalbutton" text={submitType} action={submitform} /> */}
              {!submitType?.includes("Confirm") && submitType !== "Close Load" ? (
                Delete ? (
                  <>
                    {loadingState && typeof loadingState === "boolean" ? (
                      <Button type="" text={<Spinner />} action="" disabled={true} children="" name="" />
                    ) : (
                      <Button
                        disabled={true}
                        children=""
                        type=""
                        text="Delete"
                        name="modalbutton"
                        action={handleFileDelete}
                      />
                    )}
                    {/* <Button text="Delete" name="modalbutton" action={handleFileDelete} /> */}
                    <Button action="" disabled={true} children="" type="" text="Download" name="modalbutton" />
                  </>
                ) : SaveAndClose && submitType !== "Upload" && TypeOfPortal !== "Reference" ? (
                  <>
                    {loadingState && typeof loadingState === "boolean" ? null : (
                      <Button
                        id={Form_key}
                        type=""
                        text={SaveKeyText}
                        name="modalbutton"
                        action={SaveAndClose}
                        disabled={disabled}
                        children=""
                      />
                    )}
                  </>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </>
          ) : (
            <></>
          )}

          {showCancelButton && TypeOfPortal !== "Bill By Bill" && TypeOfPortal !== "WARNING" && (
            <Button
              id="cancel-button"
              children=""
              type=""
              name="modalbutton"
              text={cancelText}
              action={handleformclose}
              onKeyDown={handleKeydownFun}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PortalFooter;
